import { ChartOptions } from "../../../orders/edit-order/edit-order.component";

export const cheese_chart_options: ChartOptions = {
  display: true,
  series: [],
  chart: {
    width: "100%",
    type: "pie"
  },
  labels: [],
  theme: {
    monochrome: {
      enabled: true
    }
  },
  title: {
    text: "Horas por trabajador"
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          position: "bottom"
        }
      }
    }
  ],
  tooltip: {
    enabled: true, // Asegúrate de que el tooltip esté habilitado
    y: {
      formatter: function (val) { //Mostramos vacio porque el tiempo ya se calcula en este caso en el label
        // const totalMinutes = Math.floor(val / 1000 / 60);
        // const hours = Math.floor(totalMinutes / 60);
        // const minutes = totalMinutes % 60;
        // return `${hours} horas ${minutes} minutos`;
        return ''
      }
    }
  },
  dataLabels: {
    enabled: true,
    formatter: function (val, opts) {
      return `${(+val).toFixed(2)}%`;
    }
  }
}